import {
  BasketballPracticeTimesApi,
  BasketballPracticeTimesSlice,
} from '@hefe/store';
import { PracticeTimesScheduleOverview } from '@hefe/ui';
import { formatDate } from '@hefe/utils';
import { Col, Row, Select } from 'antd';
import dayjs from 'dayjs';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../../../store/store';

export default function PracticeTimesPage() {
  const dispatch = useAppDispatch();

  const activeScheduleId = useSelector(
    BasketballPracticeTimesSlice.activeScheduleIdSelector
  );

  const { data: schedules, isLoading: isLoadingSchedules } =
    BasketballPracticeTimesApi.useFetchUpcomingPracticeTimesSchedulesQuery();

  const { data: scheduleData, isFetching: isLoadingSchedule } =
    BasketballPracticeTimesApi.useFetchBasketballPracticeTimesDraftOverviewQuery(
      activeScheduleId ?? 0,
      {
        skip: !activeScheduleId || activeScheduleId === 0,
      }
    );

  const schedulesSelect = useMemo(() => {
    const returnValue = schedules?.map((schedule) => {
      const today = dayjs();
      const dateIn365Days = dayjs().add(365, 'day');
      const valueFrom = schedule.from
        ? formatDate(schedule.from)
        : formatDate(today.format('YYYY-MM-DD'));
      const valueTill = schedule.till
        ? formatDate(schedule.till)
        : formatDate(dateIn365Days.format('YYYY-MM-DD'));

      return {
        label: `${schedule.name} (${valueFrom} - ${valueTill})`,
        value: schedule.id,
      };
    });

    return returnValue;
  }, [schedules]);

  return (
    <>
      <Row justify="end">
        <Col xs={24}>
          <Select
            style={{ minWidth: 300, marginBottom: 20 }}
            defaultValue={0}
            options={schedulesSelect}
            value={activeScheduleId ?? undefined}
            loading={isLoadingSchedules}
            onSelect={(value) => {
              dispatch(
                BasketballPracticeTimesSlice.actions.setActiveScheduleId(value)
              );
            }}
          />
        </Col>
      </Row>
      <Row>
        <Col span={24}>
          <PracticeTimesScheduleOverview
            data={scheduleData}
            loading={isLoadingSchedules || isLoadingSchedule}
            activeScheduleId={activeScheduleId ?? 0}
            disableEditing={true}
          />
        </Col>
      </Row>
    </>
  );
}
